import { EGeoDetailType } from '../../types/reducers/offer';
import { selectUserLocationId } from '../user';

import { createSelector } from 'reselect';
import { selectOfferGeo } from './selectOfferGeo';

export const selectLocationIds = createSelector(
  [selectUserLocationId, selectOfferGeo],
  (defaultLocationId, geo): Array<number> => {
    const address =
      geo?.address && geo.address.length
        ? geo.address
        : [
            {
              id: defaultLocationId,
              type: EGeoDetailType.Location,
            },
          ];

    return address.filter(({ type }) => type === EGeoDetailType.Location).map(({ id }) => id);
  },
);
